import { createClient } from "@supabase/supabase-js";

const supabaseUrl = 'https://exaocyxlaljqjyjrrlmj.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV4YW9jeXhsYWxqcWp5anJybG1qIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk1OTA5NzgsImV4cCI6MjA3NTE2Njk3OH0.HcMz4L31MxD2rpid4PgsUAPatBr9XcR7VOPrjCM6Qbc'
export const supabase = createClient(supabaseUrl, supabaseKey)